const state = {
  settlementSearch: localStorage.getItem('settlementSearch')
    ? JSON.parse(localStorage.getItem('settlementSearch'))
    : null, // 结算搜索条件
  settlementDetailsSearch: localStorage.getItem('settlementDetailsSearch')
    ? JSON.parse(localStorage.getItem('settlementDetailsSearch'))
    : null, // 教育局搜索条件
  settlementConfig: [], // 结算账单审核权限数据
  nodeEnum: 0, // 审批节点
  isTrueTally: 0, //  1: 实际分账单
  audit: [] // 教育局账单审批流程
}

export default state
